







































import { ClassItemType } from '@/models/enums/ClassItemType';
import ClassItem from '@/models/interfaces/ClassItem';
import ClassItemRate from '@/models/interfaces/ClassItemRate';
import { Component, Prop, Vue } from 'vue-property-decorator';
import ClassCES7Emoji from './ClassCES7Emoji.vue';
import ClassCES7Star from './ClassCES7Star.vue';
import ClassCESButton from './ClassCESButton.vue';
import ClassCSAT from './ClassCSAT.vue';
import ClassCSAT10 from './ClassCSAT10.vue';
import ClassLikeDislike from './ClassLikeDislike.vue';
import ClassNPS from './ClassNPS.vue';
import ClassOptionalLikeDislike from './ClassOptionalLikeDislike.vue';
import ClassStar from './ClassStar.vue';
import ClassEESButton from './ClassEESButton.vue';
import ClassENPS from './ClassENPS.vue';
import ClassESAT from './ClassESAT.vue';
import ClassEES7Star from './ClassEES7Star.vue';
import ClassEES7Emoji from './ClassEES7Emoji.vue';

@Component({
  components: {
    ClassLikeDislike,
    ClassOptionalLikeDislike,
    ClassNPS,
    ClassESAT,
    ClassENPS,
    ClassEESButton,
    ClassCSAT,
    ClassCSAT10,
    ClassStar,
    ClassCESButton,
    ClassCES7Star,
    ClassCES7Emoji,
    ClassEES7Star,
    ClassEES7Emoji,
  },
})
export default class Classes extends Vue {
  @Prop({ default: '' })
  public label!: string;

  /**
   * Depreciado
   * Mostra as classes em duas colunas
   */
  @Prop({ default: false })
  public twoColumns!: boolean;

  /**
   * Classes para exibir ao usuário na pesquisa
   */
  @Prop({ default: [] })
  public surveyItems!: ClassItem[];

  /**
   * resposta dos classes
   */
  @Prop({ default: [] })
  public value!: ClassItemRate[];

  /**
   * White Mode
   */
  @Prop({ default: false })
  public whiteMode!: boolean;

  @Prop({ default: false }) public readonly isWidgetChannel!: boolean;

  public get hasAnOptionalLikeDislikeClass(): boolean {
    if (this.surveyItems) {
      const itemWithOptionalLikeDislike: boolean[] = this.surveyItems.map((item) => {
        return item.type === ClassItemType.optionalLikeDislike;
      });

      return itemWithOptionalLikeDislike.includes(true);
    }
  }

  public findItemIndexById(id: number): number {
    return this.value.findIndex((item) => item.classId === id);
  }

  public setTypeOptionalOnItem(): void {
    this.surveyItems.forEach((item) => {
      if (item.type === ClassItemType.optionalLikeDislike) {
        this.value[this.findItemIndexById(item.idClass)].type = ClassItemType.optionalLikeDislike;
      }
    });
  }

  public validateAllClassesResponse(): boolean {
    const validItems: ClassItemRate[] = [];
    this.value.map((item) => {
      const isItemAnswered: boolean = item.like !== null || item.score !== null;
      if (isItemAnswered) {
        validItems.push(item);
      }
    });

    return validItems.length === this.value.length;
  }

  /**
   * Verifica mudanças
   */
  public update() {
    this.$emit('input', JSON.parse(JSON.stringify(this.value)));
    if (this.validateAllClassesResponse()) {
      this.$emit('completed', JSON.parse(JSON.stringify(this.value)));
    }
  }

  public isNPS(classItemType: string): boolean {
    return classItemType === ClassItemType.nps;
  }

  public isCSAT(classItemType: string): boolean {
    return classItemType === ClassItemType.csat;
  }

  public isENPS(classItemType: string): boolean {
    return classItemType === ClassItemType.enps;
  }

  public isESAT(classItemType: string): boolean {
    return classItemType === ClassItemType.esat;
  }

  public isEESButton(classItemType: string): boolean {
    return classItemType === ClassItemType.ees;
  }

  public isCSAT10(classItemType: string): boolean {
    return classItemType === ClassItemType.csat10;
  }

  public isCSAT5Start(classItemType: string): boolean {
    return classItemType === ClassItemType.csat5Stars;
  }

  public isOptionalLikeDislike(classItemType: string): boolean {
    return classItemType === ClassItemType.optionalLikeDislike;
  }

  public isCESButton(classItemType: string): boolean {
    return classItemType === ClassItemType.ces;
  }

  public isCES7Stars(classItemType: string): boolean {
    return classItemType === ClassItemType.ces7stars;
  }

  public isCES7Emoji(classItemType: string): boolean {
    return classItemType === ClassItemType.ces7emoji;
  }

  public isEES7Stars(classItemType: string): boolean {
    return classItemType === ClassItemType.ees7stars;
  }

  public isEES7Emoji(classItemType: string): boolean {
    return classItemType === ClassItemType.ees7emoji;
  }

  private mounted(): void {
    if (this.surveyItems) this.setTypeOptionalOnItem();
  }
}
